import { HttpMethod } from '../methods';
import { UrlConstant } from '../../Core/Interfaces/interfaces';

export const GET_TRANSCRIPT: UrlConstant = { path: '/captions/transcript', method: HttpMethod.POST };
export const GENERATE_SUMMARY: UrlConstant = { path: '/captions/transcript/summary', method: HttpMethod.POST };
export const GET_SUMMARY: UrlConstant = { path: '/captions/transcript/summary', method: HttpMethod.GET };
export const GENERATE_CORRECTION: UrlConstant = { path: '/captions/transcript/correction', method: HttpMethod.POST };
export const GET_CORRECTION: UrlConstant = { path: '/captions/transcript/correction', method: HttpMethod.GET };